import React, { useState } from 'react';
import { Check, ChevronDown, Loader2, PhoneOff, Voicemail } from 'lucide-react';
import { toast } from 'sonner';
import { api } from '../../context/AuthContext';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from '../ui/dropdown-menu';

const ERLEDIGT = [['erreicht', 'Erreicht – besprochen'], ['termin', 'Termin vereinbart'], ['meldet_sich', 'Mandant meldet sich']];
const VERSUCH = [['nicht_erreicht', 'Nicht erreicht', PhoneOff], ['mailbox', 'Mailbox / Nachricht hinterlassen', Voicemail]];
const zeit = (iso) => new Date(iso).toLocaleString('de-DE', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });

export const RueckrufVersuche = ({ versuche }) => {
  if (!versuche?.length) return null;
  const l = versuche[versuche.length - 1];
  return (
    <span className="inline-flex items-center gap-1 text-[10px] px-2 py-0.5 rounded-full bg-amber-50 text-amber-800 border border-amber-200" title={versuche.map((v) => `${zeit(v.am)} · ${v.ergebnis === 'mailbox' ? 'Mailbox' : 'nicht erreicht'} · ${v.von}`).join('\n')} data-testid="rueckruf-versuche">
      {versuche.length}. Versuch erfolglos · {zeit(l.am)}
    </span>
  );
};

export const RueckrufSchnell = ({ it, onErledigt, onVersuch }) => {
  const [busy, setBusy] = useState(false);
  const run = async (fn, ok) => {
    setBusy(true);
    try { await fn(); toast.success(ok); } catch (e) { toast.error(e?.response?.data?.detail || 'Konnte nicht gespeichert werden'); } finally { setBusy(false); }
  };
  const erledigen = (ergebnis) => run(async () => { await api.post(`/team/rueckrufe/${it.id}/erledigen`, { ergebnis }); onErledigt(it.id); }, 'Rückruf erledigt');
  const versuch = (ergebnis) => run(async () => {
    await api.post(`/team/rueckrufe/${it.id}/versuch`, { ergebnis });
    onVersuch(it.id, { am: new Date().toISOString(), ergebnis, von: 'Sie' });
  }, 'Versuch vermerkt – Rückruf bleibt offen');
  return (
    <DropdownMenu>
      <DropdownMenuTrigger disabled={busy} className="inline-flex items-center gap-1 text-[11px] tracking-wider px-3 py-1.5 rounded-full border border-[#b8893d] text-[#7a5a22] hover:bg-[#b8893d] hover:text-white transition-colors duration-200 outline-none" data-testid={`planer-rueckruf-ergebnis-${it.id}`}>
        {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <Check className="w-3 h-3" />} ERGEBNIS <ChevronDown className="w-3 h-3" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[240px]">
        <p className="px-2 pt-1.5 pb-1 text-[10px] tracking-[0.2em] uppercase text-emerald-700">Abschließen</p>
        {ERLEDIGT.map(([k, l]) => <DropdownMenuItem key={k} onClick={() => erledigen(k)} className="text-xs cursor-pointer" data-testid={`planer-rueckruf-${k}-${it.id}`}><Check className="w-3.5 h-3.5 mr-2 text-emerald-600" />{l}</DropdownMenuItem>)}
        <DropdownMenuSeparator />
        <p className="px-2 pt-1 pb-1 text-[10px] tracking-[0.2em] uppercase text-amber-700">Bleibt offen</p>
        {VERSUCH.map(([k, l, I]) => <DropdownMenuItem key={k} onClick={() => versuch(k)} className="text-xs cursor-pointer" data-testid={`planer-rueckruf-${k}-${it.id}`}><I className="w-3.5 h-3.5 mr-2 text-amber-600" />{l}</DropdownMenuItem>)}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
